<template>
  <div class="button-body">
    <div class="buttons">
      <button class="button" @click="postCreateBookGroupCoupon">
        クーポン発行(Dev/Stgのみ)
        <span style="float: right">></span>
      </button>
    </div>
  </div>
</template>

<script>
import API from "@/API";
import userInfoService from "@/services/userInfo";
import moment from "@/services/moment";

export default {
  name: "DbsCouponButton",
  methods: {
    async postCreateBookGroupCoupon() {
      try {
        // POST /createBookGroup のリクエストボディを作成
        const apiParams = {
          master_book_id: process.env.VUE_APP_ENV === "staging" ? 632 : 517, // stg : dev
          user_id: userInfoService.getUserIdFromIdToken(),
          started_at: moment(new Date()).format(),
          count: 1,
        };
        await API.createBookGroup(apiParams);
        alert("クーポン発行に成功しました");
      } catch (e) {
        alert("クーポン発行に失敗しました");
      }
    },
  },
};
</script>

<style lang="scss">
.button-body .buttons .button {
  display: block;
  background-color: #ffffff;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: normal;
  color: #000000;
  text-decoration: none;
  border: 1px solid #e0e0e0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
</style>
